import {FONT_SIZES, Text} from '@aboutyou/ui-components';
import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

export const CouponDiscountValue: FC<
  PropsWithChildren<{
    ['data-testid']?: string;
    size?: keyof typeof FONT_SIZES;
    className?: string;
  }>
> = ({'data-testid': dataTestId, children, size = 'px20', className}) => {
  return (
    <DiscountValue
      size={size}
      color="inherit"
      data-testid={dataTestId}
      className={className}
    >
      {children}
    </DiscountValue>
  );
};

const DiscountValue = styled(Text)`
  font-weight: 800;
  padding: 14px;
`;
